import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TabContext from "@/contexts/TabContext";
import { branchTypeOptions } from "@/constants/selectOptions";
import { comma, dateFormatToISOString, ReservationStatusType, useListPageFilter } from "@/utils";
import { Confirm, PageTabs, Pagination, Toast } from "@/components";
import ReactDOM from "react-dom";

import DatePicker from "react-datepicker";
import ko from "date-fns/locale/ko";
import Select from "react-select";
import {
    useGetChargeDetailAdminMutation,
    useGetChargeListAdminQuery,
    usePostChargeFaxFileMutation,
    usePostChargeFaxSendMutation,
    usePutChargeCalculateMutation,
    usePutChargeCommissionMutation,
} from "../../redux/adminChargeApi";
import { InputPopup } from "../../components";
import { validateCarNumber } from "../../utils";
import {
    useGetAosManagerAdminMutation,
    useGetAosReceiptInfoAdminMutation,
    useGetReceiptInfoAdminMutation,
    usePostAosChargeRequestAdminMutation,
} from "../../redux/adminAosApi";

// 페이지 기본 필터
const pageFilter = {
    parameters: {
        page: 0,
        size: 20,
        query: "",
        status: "",
        started_at: "",
        ended_at: "",
    },
};

export const AdminBillingStatus = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { state: tabs, dispatch } = useContext(TabContext);

    // 탭(토글) 상태: 1 / 2
    const [currentTab, setCurrentTab] = useState(1);

    const { formData, handleChange, setFormData, parameters, toastMsg } = useListPageFilter(pageFilter, {
        confirmStatus: {
            confirmPopupStatus: false,
            confirmTitle: "",
            confirmDescription: "",
            confirmButtons: [],
        },
        chargePopupStatus: false,
        orderDetailPopupStatus: false,
        signLinkGuidePopupStatus: false,
        triggerSearch: false,
        showAosTableYn: "N",
        showAosManagerTableYn: "N",
        aosReceiptData: [],
        aosManagerData: [],
        aosConfirmText: "조회",
        aosConfirmButtonDisable: false,
        selectedAosReceipt: undefined,
        selectedAosManager: undefined,
        selectedCharge: undefined,
    });

    const {
        confirmStatus,
        orderDetailPopupStatus,
        signLinkGuidePopupStatus,
        triggerSearch,
        chargePopupStatus,
        aosCarNumber,
        aosReceiptNumber,
        showAosTableYn,
        showAosManagerTableYn,
        aosReceiptData,
        aosManagerData,
        aosConfirmText,
        aosConfirmButtonDisable,
        selectedAosReceipt,
        selectedAosManager,
        selectedCharge,
    } = formData;

    const [detailPopupStatus, setDetailPopupStatus] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [selectedAosItem, setSelectedAosItem] = useState(null);
    const [selectedAosManagerItem, setSelectedAosManagerItem] = useState(null);

    const [getAosReceiptInfo] = useGetAosReceiptInfoAdminMutation();
    const [getAosManager] = useGetAosManagerAdminMutation();
    const [postAosCharge] = usePostAosChargeRequestAdminMutation();

    // 탭 추가 로직
    useEffect(() => {
        const handleTabAdd = () => {
            const existingTab = tabs.find((tab) => tab.url.split("?")[0] === location.pathname);
            if (!existingTab) {
                dispatch({
                    type: "ADD_TAB",
                    payload: { url: location.pathname + location.search, title: "청구 목록" },
                });
            }
        };
        handleTabAdd();
    }, [dispatch, location.pathname, location.search, tabs]);

    // currentTab 값에 따라 API 호출
    const { data, error, refetch } = useGetChargeListAdminQuery(parameters, {
        refetchOnMountOrArgChange: true,
        skip: !triggerSearch,
    });

    // 컴포넌트 마운트 시 초기 데이터 조회
    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            triggerSearch: true,
        }));
    }, []);

    useEffect(() => {
        if (!selectedAosItem) {
            setFormData((prev) => ({
                ...prev,
                aosConfirmButtonDisable: false,
                aosConfirmText: "조회",
            }));
        } else {
            console.log(selectedAosItem);
            if (selectedAosItem.damcstnuid) {
                setFormData((prev) => ({
                    ...prev,
                    aosConfirmButtonDisable: false,
                    aosConfirmText: "청구하기",
                }));
            } else {
                setFormData((prev) => ({
                    ...prev,
                    aosConfirmButtonDisable: false,
                    aosConfirmText: "담당자 AOS 조회",
                }));
            }
        }
    }, [selectedAosItem]);

    useEffect(() => {
        if (!selectedAosManagerItem) {
            setFormData((prev) => ({
                ...prev,
                aosConfirmButtonDisable: true,
                aosConfirmText: "청구하기",
            }));
        } else {
            if (selectedAosManagerItem.aosid) {
                setFormData((prev) => ({
                    ...prev,
                    aosConfirmButtonDisable: false,
                    aosConfirmText: "청구하기",
                }));
            } else {
                setFormData((prev) => ({
                    ...prev,
                    aosConfirmButtonDisable: true,
                    aosConfirmText: "AOS ID 미존재",
                }));
            }
        }
    }, [selectedAosManagerItem]);

    // 검색 버튼 클릭
    const handleSearch = () => {
        setFormData((prev) => ({
            ...prev,
            parameters: { ...prev.parameters, page: 0 },
            triggerSearch: true,
        }));
    };

    const requestAosCharge = async (requestBody) => {
        try {
            console.log(`request body [${JSON.stringify(requestBody)}]`);
            console.log(`selectedCharge [${JSON.stringify(selectedCharge)}] `);

            const response = await postAosCharge({
                chargeId: selectedCharge.id,
                data: requestBody,
            }).unwrap();

            console.log(response.data);

            setFormData((prev) => ({
                ...prev,
                toastMsg: "청구신청이 완료되었습니다.",
                showAosTableYn: "N",
                showAosManagerTableYn: "N",
                chargePopupStatus: false,
            }));
            return;
        } catch (error) {
            console.log(error);
            setFormData((prev) => ({
                ...prev,
                toastMsg: error?.message || "담당자 조회 실패",
            }));
            return;
        }
    };

    const handleGetAosReceiptInfo = async (values) => {
        const { inputValues, radioValues, moduleStates } = values;
        const aosCarNumber = inputValues.aosCarNumber;
        const aosReceiptNumber = inputValues.aosReceiptNumber;
        const selectedAosReceiptIndex = moduleStates.selectedAosReceipt;
        const selectedAosManagerIndex = moduleStates.selectedAosManager;

        console.log(`selectedAosReceiptIndex[${selectedAosReceiptIndex}] selectedAosManagerIndex[${selectedAosManagerIndex}]`);

        if (selectedAosManagerIndex !== undefined) {
            let selectedManager = formData.aosManagerData?.data[selectedAosManagerIndex];
            setFormData((prev) => ({
                ...prev,
                selectedAosManager: selectedManager,
            }));
            if (formData.selectedAosReceipt) {
                let aosChargeRequestBody = {
                    inscd: formData.selectedAosReceipt.inscd,
                    insnm: formData.selectedAosReceipt.insnm,
                    accno: formData.selectedAosReceipt.accno,
                    carnum: aosCarNumber,
                    mrtgcd: formData.selectedAosReceipt.mrtgcd,
                    mrtgnm: formData.selectedAosReceipt.mrtgnm,
                    ordrank: formData.selectedAosReceipt.ordrank,
                    damcstnnm: selectedManager.usernm,
                    damcstnuid: selectedManager.aosid,
                };
                await requestAosCharge(aosChargeRequestBody);
            }
        } else if (selectedAosReceiptIndex !== undefined) {
            let selectedAosReceiptData = formData.aosReceiptData?.data[selectedAosReceiptIndex];
            setFormData((prev) => ({
                ...prev,
                selectedAosReceipt: selectedAosReceiptData,
            }));
            if (selectedAosReceiptData.damcstnuid) {
                let aosChargeRequestBody = {
                    inscd: selectedAosReceiptData.inscd,
                    insnm: selectedAosReceiptData.insnm,
                    accno: selectedAosReceiptData.accno,
                    carnum: aosCarNumber,
                    mrtgcd: selectedAosReceiptData.mrtgcd,
                    mrtgnm: selectedAosReceiptData.mrtgnm,
                    ordrank: selectedAosReceiptData.ordrank,
                    damcstnnm: selectedAosReceiptData.damcstnnm,
                    damcstnuid: selectedAosReceiptData.damcstnuid,
                };
                await requestAosCharge(aosChargeRequestBody);
            } else {
                //console.log('보상담당자 aos id 없음');
                try {
                    const aosManagerResponse = await getAosManager({
                        name: selectedAosReceiptData.damcstnnm,
                        insurance_code: selectedAosReceiptData.inscd,
                    }).unwrap();

                    setFormData((prev) => ({
                        ...prev,
                        showAosTableYn: "N",
                        showAosManagerTableYn: "Y",
                        aosManagerData: aosManagerResponse,
                        aosConfirmButtonDisable: true,
                        aosConfirmText: "청구하기",
                    }));
                } catch (error) {
                    //console.log(error);
                    setFormData((prev) => ({
                        ...prev,
                        toastMsg: error?.message || "담당자 조회 실패",
                    }));
                }
            }
        } else {
            if (!validateCarNumber(aosCarNumber)) {
                setFormData((prev) => ({
                    ...prev,
                    toastMsg: "차량번호가 올바르지 않습니다.",
                }));
                return;
            }

            try {
                const aosReceiptInfoData = await getAosReceiptInfo({
                    car_number: aosCarNumber,
                    receipt_number: aosReceiptNumber,
                }).unwrap();

                setFormData((prev) => ({
                    ...prev,
                    showAosTableYn: "Y",
                    showAosManagerTableYn: "N",
                    aosReceiptData: aosReceiptInfoData,
                    aosCarNumber: aosCarNumber,
                    aosReceiptNumber: aosReceiptNumber,
                    selectedAosReceipt: undefined,
                    selectedAosManager: undefined,
                    aosConfirmButtonDisable: true,
                }));
            } catch (error) {
                setFormData((prev) => ({
                    ...prev,
                    toastMsg: error?.message || "청구 상세조회 실패",
                }));
            }
        }
    };

    // 삭제 버튼
    const handleDelete = () => {
        setFormData((prev) => ({
            ...prev,
            confirmStatus: {
                confirmPopupStatus: true,
                confirmTitle: "서명 요청 취소",
                confirmDescription: "해당 계약서를 삭제 하시겠습니까?",
                confirmButtons: [
                    { label: "예", className: "btn-primary", onClick: console.log("삭제") },
                    {
                        label: "아니오",
                        className: "btn-cancel",
                        onClick: () =>
                            setFormData((prev2) => ({
                                ...prev2,
                                confirmStatus: { confirmPopupStatus: false },
                            })),
                    },
                ],
            },
        }));
    };

    const handleDetailClick = (item) => {
        setSelectedItem(item);
        setDetailPopupStatus(true);
    };

    const handleCloseDetail = () => {
        setDetailPopupStatus(false);
        setSelectedItem(null);
    };

    return (
        <>
            {toastMsg && <Toast visible={true} msg={toastMsg} setFormData={setFormData} />}

            <div className="management container">
                <PageTabs />

                <div className="table-container">
                    <div className="table-head">
                        <span className="head-tit">청구 목록</span>
                        <div className="breadcrumbs">
                            <ul>
                                <li className="home"></li>
                                <li>ERP 관리</li>
                                <li>청구 목록</li>
                            </ul>
                        </div>
                    </div>
                    <TableFilter formData={formData} handleChange={handleChange} setFormData={setFormData} handleSearch={handleSearch} />

                    <div className="table-content">
                        <div className="table-option">
                            <div className="table-caption">
                                {/* <div className="toggle-list">
                                    <button
                                        type="button"
                                        className={`btn-toggle ${currentTab === 1 ? "active" : ""}`}
                                        onClick={() => setCurrentTab(1)}
                                    >
                                        청구 현황
                                    </button>
                                    <button
                                        type="button"
                                        className={`btn-toggle ${currentTab === 2 ? "active" : ""}`}
                                        onClick={() => setCurrentTab(2)}
                                    >
                                        수납 현황
                                    </button>
                                    <button
                                        type="button"
                                        className={`btn-toggle ${currentTab === 3 ? "active" : ""}`}
                                        onClick={() => setCurrentTab(3)}
                                    >
                                        지급 현황
                                    </button>
                                </div> */}
                                <span className="data-count">{/* 전체 <b>{data?.pagination?.totalElements}</b>건 */}</span>
                            </div>
                            <div className="table-buttons"></div>
                        </div>

                        <div className="table-wrapper">
                            <div className="table">
                                <table>
                                    <colgroup>
                                        <col width="10%" />
                                        <col width="10%" />
                                        <col width="10%" />
                                        <col width="10%" />
                                        <col width="10%" />
                                        <col width="10%" />
                                        <col width="10%" />
                                        <col width="10%" />
                                        <col width="10%" />
                                        <col width="10%" />
                                        <col width="10%" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">ID</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">업체명</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">보험사명</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">보험접수번호</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">보험사 팩스번호</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">사고차량번호</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">청구시도횟수</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">팩스전송여부</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">대여일수</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">총대여료</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">보험사 청구금</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">오더상세</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">상세보기</span>
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data && data.data && data.data.length > 0 ? (
                                            data.data.map((item, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">{item.id || "-"}</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">{item.rentCorp?.corpName || "-"}</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">
                                                                {item.contractGroup?.contractInsurance?.insuranceCorpName || "-"}
                                                            </span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">
                                                                {item.contractGroup?.contractInsurance?.receiptNumber || "-"}
                                                            </span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">{item.faxNumber || "-"}</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">
                                                                {item.contractGroup?.accidentCar?.carNumber || "-"}
                                                            </span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">{item.chargeCount || 0}</span>
                                                        </div>
                                                    </td>

                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <span
                                                                className="cell-dag tag-box"
                                                                style={{
                                                                    backgroundColor: !item.faxSentAt
                                                                        ? "#ffebee"
                                                                        : item.faxStatus === "PENDING"
                                                                        ? "#e8f5e9"
                                                                        : item.faxStatus === "FAIL"
                                                                        ? "#ffebee"
                                                                        : item.faxStatus === "FINISH"
                                                                        ? "#87CEFA"
                                                                        : "#e8f5e9",
                                                                }}
                                                            >
                                                                {!item.faxSentAt
                                                                    ? "미전송"
                                                                    : item.faxStatus === "PENDING"
                                                                    ? "전송중"
                                                                    : item.faxStatus === "FAIL"
                                                                    ? "전송실패"
                                                                    : item.faxStatus === "FINISH"
                                                                    ? "전송완료"
                                                                    : ""}
                                                            </span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">
                                                                {item.totalRentDays === 0
                                                                    ? (item.totalRentHours || "0") + "시간"
                                                                    : item.totalRentHours === 0
                                                                    ? (item.totalRentDays || "0") + "일"
                                                                    : (item.totalRentDays || "0") +
                                                                      "일 " +
                                                                      (item.totalRentHours || "0") +
                                                                      "시간"}
                                                            </span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">{comma(item.totalRentFee)}원</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">{comma(item.totalInsuranceChargeFee)}원</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            {item.contractGroup?.orderId ? (
                                                                <button
                                                                    type="button"
                                                                    className="btn-cell btn-outline"
                                                                    onClick={() =>
                                                                        navigate(`/erp/order/detail/${item.contractGroup?.orderId}`)
                                                                    }
                                                                >
                                                                    오더상세
                                                                </button>
                                                            ) : (
                                                                <></>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <button
                                                                type="button"
                                                                className="btn-cell btn-outline"
                                                                onClick={() => handleDetailClick(item)}
                                                            >
                                                                상세보기
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="10" className="data-empty">
                                                    <div className="cell" data-align="center">
                                                        <span className="cell-desc">데이터가 없습니다.</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        {data?.data?.length ? <Pagination pagination={data?.pagination} setFormData={setFormData} /> : null}
                    </div>
                </div>
            </div>

            {/* Confirm 팝업 */}
            {confirmStatus?.confirmPopupStatus && (
                <Confirm
                    layer={true}
                    layerClassName={confirmStatus?.layerClassName}
                    onClose={() =>
                        setFormData((prev) => ({
                            ...prev,
                            confirmStatus: { confirmPopupStatus: false },
                        }))
                    }
                    title={confirmStatus.confirmTitle}
                    description={confirmStatus.confirmDescription}
                    buttons={confirmStatus.confirmButtons}
                />
            )}

            {/* 상세보기 팝업 */}
            {detailPopupStatus && selectedItem && (
                <BillingDetailPopup
                    formData={formData}
                    setFormData={setFormData}
                    popupStatus={detailPopupStatus}
                    onClose={handleCloseDetail}
                    viewData={selectedItem}
                    setSelectedItem={setSelectedItem}
                    refetch={refetch}
                />
            )}

            {chargePopupStatus && (
                <InputPopup
                    title="AOS 청구 신청"
                    description="사고차량번호로 접수정보를 조회해주세요."
                    width="920px"
                    inputs={[
                        {
                            name: "aosCarNumber",
                            label: "사고차량번호",
                            type: "text",
                            placeholder: "사고차량번호를 확인해주세요.",
                            value: aosCarNumber,
                        },
                        {
                            name: "aosReceiptNumber",
                            label: "접수번호",
                            type: "text",
                            placeholder: "접수번호를 확인해주세요.",
                            value: aosReceiptNumber,
                        },
                    ]}
                    modules={[
                        {
                            type: "aosReceiptSelection",
                            props: {},
                            showYn: showAosTableYn,
                            selectItems: aosReceiptData,
                            setSelectedAosItem: setSelectedAosItem,
                        },
                        {
                            type: "aosManagerSelection",
                            props: {},
                            showYn: showAosManagerTableYn,
                            selectItems: aosManagerData,
                            setSelectedAosManager: setSelectedAosManagerItem,
                        },
                    ]}
                    buttons={[
                        {
                            label: "취소",
                            className: "btn-cancel",
                            onClick: () => {
                                setFormData((prev) => ({
                                    ...prev,
                                    chargePopupStatus: false,
                                }));
                            },
                        },
                        {
                            label: aosConfirmText,
                            className: "btn-primary",
                            closeOnClick: false,
                            disabled: aosConfirmButtonDisable,
                            onClick: handleGetAosReceiptInfo,
                        },
                    ]}
                    onClose={() => {
                        setFormData((prev) => ({
                            ...prev,
                            chargePopupStatus: false,
                        }));
                    }}
                />
            )}
        </>
    );
};

const TableFilter = ({ formData, setFormData, handleSearch }) => {
    const [filterOption, setFilterOption] = useState([]);
    const [clientLabel, setClientLabel] = useState({});
    const [statusLabel, setStatusLabel] = useState({});

    const { parameters } = formData;
    const [activeButton, setActiveButton] = useState(null);

    // const { data, error, isLoading } = useGetClientNameListQuery();

    // useEffect(() => {
    //     if (data?.data) {
    //         var res = [{ value: null, label: "전체" }];
    //         data?.data?.forEach((i) => {
    //             res.push({ value: i.id, label: i.clientCorName });
    //         });
    //         setFilterOption(res);
    //     }
    // }, [data]);

    const handleParameterChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            parameters: {
                ...prev.parameters,
                [name]: value,
            },
            triggerSearch: false,
        }));
    };

    const handleDateChange = (dates, type) => {
        const [start, end] = dates;

        if (type === 1) {
            setFormData((prev) => ({
                ...prev,
                parameters: {
                    ...prev.parameters,
                    started_at: start ? dateFormatToISOString(start, "start") : "",
                    ended_at: end ? dateFormatToISOString(end, "end") : "",
                },
                triggerSearch: false,
            }));
        }

        if (type === "service") {
            setFormData((prev) => ({
                ...prev,
                parameters: {
                    ...prev.parameters,
                    reserveDateStart: start ? dateFormatToISOString(start, "start") : "",
                    reserveDateEnd: end ? dateFormatToISOString(end, "end") : "",
                },
                triggerSearch: false,
            }));
        }

        setActiveButton(null);
    };

    const setDateRange = (days, buttonIndex) => {
        const now = new Date();
        const start = new Date(now);
        start.setDate(start.getDate() - days);

        setFormData((prev) => ({
            ...prev,
            parameters: {
                ...prev.parameters,
                page: 0,
                started_at: dateFormatToISOString(start, "start"),
                ended_at: dateFormatToISOString(now, "end"),
            },
            triggerSearch: false,
        }));

        setActiveButton(buttonIndex);
    };

    return (
        <div className="table-filter">
            <div className="filter-row">
                <div className="filter-item">
                    <div className="item-head">
                        <span className="head-tit">상태 :</span>
                    </div>
                    <div className="item-content">
                        <div className="item-select">
                            <Select
                                options={ReservationStatusType}
                                className="filter-select"
                                classNamePrefix="filter-select"
                                isSearchable={false}
                                placeholder="진행현황"
                                value={statusLabel}
                                onChange={(option) => {
                                    setFormData((prev) => ({
                                        ...prev,
                                        parameters: {
                                            ...prev.parameters,
                                            status: option.value,
                                        },
                                    }));
                                    setStatusLabel(option);
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="filter-item">
                    <div className="item-head">
                        <span className="head-tit">등록일 :</span>
                    </div>
                    <div className="item-content">
                        <div className="item-input">
                            <DatePicker
                                locale={ko}
                                showYearDropdown
                                scrollableYearDropdown
                                yearDropdownItemNumber={20}
                                dateFormat="yyyy.MM.dd"
                                onKeyDown={(e) => e.preventDefault()}
                                selectsRange={true}
                                startDate={parameters.started_at ? new Date(parameters.started_at) : null}
                                endDate={parameters.ended_at ? new Date(parameters.ended_at) : null}
                                onChange={(e) => handleDateChange(e, 1)}
                            />
                        </div>
                    </div>
                </div>
                <div className="filter-item">
                    <div className="item-content">
                        <div className="item-buttons">
                            <button
                                type="button"
                                className={`btn-toggle ${activeButton === 0 ? "active" : ""}`}
                                onClick={() => setDateRange(0, 0)}
                            >
                                당일
                            </button>
                            <button
                                type="button"
                                className={`btn-toggle ${activeButton === 15 ? "active" : ""}`}
                                onClick={() => setDateRange(15, 15)}
                            >
                                15일
                            </button>
                            <button
                                type="button"
                                className={`btn-toggle ${activeButton === 30 ? "active" : ""}`}
                                onClick={() => setDateRange(30, 30)}
                            >
                                1개월
                            </button>
                            <button
                                type="button"
                                className={`btn-toggle ${activeButton === 90 ? "active" : ""}`}
                                onClick={() => setDateRange(90, 90)}
                            >
                                3개월
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="filter-row">
                <div className="filter-item">
                    <div className="item-content">
                        <div className="item-input" style={{ width: "300px" }}>
                            <input
                                type="text"
                                placeholder="입력하세요."
                                name="query"
                                value={parameters.query}
                                onChange={handleParameterChange}
                            />
                        </div>
                        <div className="item-buttons">
                            <button type="button" className="btn-search" onClick={handleSearch}>
                                검색
                            </button>
                            <button
                                type="button"
                                className="btn-search"
                                onClick={() => {
                                    setFormData((prev) => ({
                                        ...prev,
                                        ...pageFilter,
                                    }));
                                    setClientLabel({ value: null, label: "전체" });
                                }}
                            >
                                초기화
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// 상세보기 팝업 컴포넌트
const BillingDetailPopup = ({ formData, setFormData, popupStatus, layer = true, onClose, viewData, setSelectedItem, refetch }) => {
    const navigate = useNavigate();
    const [isVisible, setIsVisible] = useState(false);
    const [postFaxSend] = usePostChargeFaxSendMutation();
    const [postFaxFile] = usePostChargeFaxFileMutation();
    const [putChargeCalculate] = usePutChargeCalculateMutation();
    const [putChargeCommission] = usePutChargeCommissionMutation();
    const [getChargeDetail] = useGetChargeDetailAdminMutation();

    const [faxNumber, setFaxNumber] = useState(viewData.faxNumber || "");

    useEffect(() => {
        if (popupStatus) {
            setFaxNumber(viewData.faxNumber || "");
            const timer = setTimeout(() => {
                setIsVisible(true);
            }, 10);
            return () => clearTimeout(timer);
        }
    }, [popupStatus, viewData.faxNumber]);

    const handleClose = () => {
        setIsVisible(false);
        setTimeout(() => {
            onClose();
        }, 200);
    };

    useEffect(() => {
        document.body.classList.add("scroll-lock");
        return () => {
            document.body.classList.remove("scroll-lock");
        };
    }, []);

    const handleAosCharge = async () => {
        try {
            const chargeData = await getChargeDetail(viewData.id).unwrap();
            setFormData((prev) => ({
                ...prev,
                chargePopupStatus: true,
                aosCarNumber: chargeData?.data?.contractGroup?.accidentCar?.carNumber ?? "",
                aosReceiptNumber: chargeData?.data?.contractGroup?.contractInsurance?.receiptNumber ?? "",
                showAosTableYn: "N",
                showAosManagerTableYn: "N",
                selectedAosReceipt: undefined,
                selectedAosManager: undefined,
                selectedCharge: chargeData?.data,
                aosConfirmButtonDisable: false,
                aosConfirmText: "조회",
            }));

            handleClose();
        } catch (error) {
            setFormData((prev) => ({
                ...prev,
                toastMsg: error?.message || "청구 상세조회 실패",
            }));
        }
    };

    // 팩스 전송 버튼 클릭 시
    const handleFaxSend = () => {
        if (!faxNumber) {
            setFormData((prev) => ({ ...prev, toastMsg: "보험사 팩스번호가 없습니다." }));
            setTimeout(() => setFormData((prev) => ({ ...prev, toastMsg: "" })), 2000);
            return;
        }
        setFormData((prev) => ({
            ...prev,
            confirmStatus: {
                layerClassName: "active_transparent",
                confirmPopupStatus: true,
                confirmTitle: "팩스 전송",
                confirmDescription: `팩스번호(${faxNumber})로 전송하시겠습니까?`,
                confirmButtons: [
                    {
                        label: "예",
                        className: "btn-primary",
                        onClick: async () => {
                            try {
                                const requestBody = {
                                    faxNumber: faxNumber,
                                };
                                await postFaxSend({ chargeId: viewData.id, body: requestBody }).unwrap();
                                if (refetch) refetch();
                                setFormData((prev2) => ({
                                    ...prev2,
                                    toastMsg: "팩스 전송이 완료되었습니다.",
                                    confirmStatus: { confirmPopupStatus: false },
                                }));
                            } catch (e) {
                                setFormData((prev2) => ({
                                    ...prev2,
                                    toastMsg: e.message || "팩스 전송에 실패했습니다.",
                                    confirmStatus: { confirmPopupStatus: false },
                                }));
                            }
                            setTimeout(() => setFormData((prev2) => ({ ...prev2, toastMsg: "" })), 2000);
                        },
                    },
                    {
                        label: "아니오",
                        className: "btn-cancel",
                        onClick: () => setFormData((prev2) => ({ ...prev2, confirmStatus: { confirmPopupStatus: false } })),
                    },
                ],
            },
        }));
    };

    const handleFaxFileView = async () => {
        let response = await putChargeCalculate(viewData.id).unwrap();

        setSelectedItem(response.data);
        if (refetch) refetch();

        if (!response.data?.faxFileUrl) {
            setFormData((prev2) => ({
                ...prev2,
                toastMsg: "청구파일이 생성되어 있지 않습니다.",
                confirmStatus: { confirmPopupStatus: false },
            }));
        } else {
            window.open(response.data?.faxFileUrl, "_blank");
        }
    };

    const handleChargeCalculate = async () => {
        let response = await putChargeCalculate(viewData.id).unwrap();

        setSelectedItem(response.data);
        if (refetch) refetch();
        setFormData((prev2) => ({
            ...prev2,
            toastMsg: "계산이 완료되었습니다.",
            confirmStatus: { confirmPopupStatus: false },
        }));
    };

    const handleCommission = async () => {
        let response = await putChargeCommission(viewData.id).unwrap();

        setSelectedItem(response.data);
        if (refetch) refetch();
        setFormData((prev2) => ({
            ...prev2,
            toastMsg: "수수료정산이 완료되었습니다.",
            confirmStatus: { confirmPopupStatus: false },
        }));
    };

    // 팩스파일 생성 버튼 클릭 시 (팩스번호는 사용하지 않음)
    const handleFaxFileCreate = () => {
        setFormData((prev) => ({
            ...prev,
            confirmStatus: {
                layerClassName: "active_transparent",
                confirmPopupStatus: true,
                confirmTitle: "팩스파일 생성",
                confirmDescription: `팩스파일을 생성하시겠습니까?`,
                confirmButtons: [
                    {
                        label: "예",
                        className: "btn-primary",
                        onClick: async () => {
                            try {
                                await postFaxFile(viewData.id).unwrap();
                                if (refetch) refetch();
                                setFormData((prev2) => ({
                                    ...prev2,
                                    toastMsg: "팩스 파일이 생성되었습니다.",
                                    confirmStatus: { confirmPopupStatus: false },
                                }));
                            } catch (e) {
                                setFormData((prev2) => ({
                                    ...prev2,
                                    toastMsg: e.message || "팩스 파일 생성에 실패했습니다.",
                                    confirmStatus: { confirmPopupStatus: false },
                                }));
                            }
                            setTimeout(() => setFormData((prev2) => ({ ...prev2, toastMsg: "" })), 2000);
                        },
                    },
                    {
                        label: "아니오",
                        className: "btn-cancel",
                        onClick: () => setFormData((prev2) => ({ ...prev2, confirmStatus: { confirmPopupStatus: false } })),
                    },
                ],
            },
        }));
    };

    const handleContractDetail = () => {
        if (viewData.contractGroup?.id) {
            navigate(`/contract/detail/${viewData.contractGroup.id}`);
        } else {
            setFormData((prev) => ({ ...prev, toastMsg: "contractGroupId가 없습니다." }));
            setTimeout(() => setFormData((prev) => ({ ...prev, toastMsg: "" })), 2000);
        }
    };

    return ReactDOM.createPortal(
        <>
            <div className={layer ? "layer active" : "layer"} onClick={handleClose}></div>

            <div className={`popup popup-side billing-detail-popup ${isVisible ? "active" : ""}`}>
                <div className="popup-head">
                    <div className="head-tit">
                        <span className="tit-main">청구 상세</span>
                    </div>
                    <div className="btn-close" onClick={handleClose}></div>
                </div>
                <div className="popup-content">
                    <div className="side_item-container">
                        <div className="side_item-wrapper">
                            <div className="side_item">
                                <div className="side_item-head">
                                    <span className="head-tit">기본 정보</span>
                                </div>
                                <div className="side_item-body">
                                    <div className="row-item">
                                        <span className="item-tit">업체명</span>
                                        <span className="item-desc">{viewData.rentCorp?.corpName || "-"}</span>
                                    </div>
                                    <div className="row-item">
                                        <span className="item-tit">보험접수번호</span>
                                        <span className="item-desc">{viewData.contractGroup?.contractInsurance?.receiptNumber || "-"}</span>
                                    </div>
                                    <div className="row-item">
                                        <span className="item-tit">사고차량번호</span>
                                        <span className="item-desc">{viewData.contractGroup?.accidentCar?.carNumber || "-"}</span>
                                    </div>
                                    <div className="row-item">
                                        <span className="item-tit">청구시도횟수</span>
                                        <span className="item-desc">{viewData.chargeCount || 0}</span>
                                    </div>
                                    <div className="row-item">
                                        <span className="item-tit">보험사 팩스번호</span>
                                        <span className="item-input">
                                            <input type="text" value={faxNumber} onChange={(e) => setFaxNumber(e.target.value)} />
                                        </span>
                                    </div>
                                    <div className="row-item">
                                        <span className="item-tit">팩스전송여부</span>
                                        <span className="item-desc">
                                            <span
                                                className="cell-dag tag-box"
                                                style={{
                                                    backgroundColor: !viewData.faxStatus
                                                        ? "#ffebee"
                                                        : viewData.faxStatus === "PENDING"
                                                        ? "#e8f5e9"
                                                        : viewData.faxStatus === "FAIL"
                                                        ? "#ffebee"
                                                        : viewData.faxStatus === "FINISH"
                                                        ? "#e8f5e9"
                                                        : "#e8f5e9",
                                                }}
                                            >
                                                {!viewData.faxSentAt
                                                    ? "미전송"
                                                    : viewData.faxStatus === "PENDING"
                                                    ? "전송중"
                                                    : viewData.faxStatus === "FAIL"
                                                    ? "전송실패"
                                                    : viewData.faxStatus === "FINISH"
                                                    ? "전송완료"
                                                    : ""}
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="side_item">
                                <div className="side_item-head">
                                    <span className="head-tit">대여 정보</span>
                                </div>
                                <div className="side_item-body">
                                    <div className="row-item">
                                        <span className="item-tit">대여일수</span>
                                        <span className="item-desc">
                                            {viewData.totalRentDays || "-"}일 {viewData.rentHours || "0"}시간
                                        </span>
                                    </div>
                                    <div className="row-item">
                                        <span className="item-tit">총대여료</span>
                                        <span className="item-desc">{comma(viewData.totalRentFee)}원</span>
                                    </div>
                                    <div className="row-item">
                                        <span className="item-tit">보험사 청구금</span>
                                        <span className="item-desc">{comma(viewData.totalInsuranceChargeFee)}원</span>
                                    </div>
                                    <div className="row-item">
                                        <span className="item-tit">청구율</span>
                                        <span className="item-desc">{viewData.chargeRate || "-"}%</span>
                                    </div>
                                    <div className="row-item">
                                        <span className="item-tit">플랫폼 수수료율</span>
                                        <span className="item-desc">{viewData.platformCommissionRate || "-"}%</span>
                                    </div>
                                    <div className="row-item">
                                        <span className="item-tit">플랫폼 쉐어수수료율</span>
                                        <span className="item-desc">{viewData.platformCommissionShareRate || "-"}%</span>
                                    </div>
                                    <div className="row-item">
                                        <span className="item-tit">오더자수수료율</span>
                                        <span className="item-desc">{viewData.orderCommissionRate || "-"}%</span>
                                    </div>
                                </div>
                            </div>

                            <div className="side_item">
                                <div className="side_item-head">
                                    <span className="head-tit">마일리지 정보</span>
                                </div>
                                <div className="side_item-body">
                                    <div className="row-item">
                                        <span className="item-tit">오더자 마일리지</span>
                                        <span className="item-desc">{comma(viewData.orderMemberMileage || "0")}</span>
                                    </div>
                                    <div className="row-item">
                                        <span className="item-tit">수주자 마일리지</span>
                                        <span className="item-desc">{comma(viewData.obtainMemberMileage || "0")}</span>
                                    </div>
                                </div>
                            </div>

                            <div className="side_item">
                                <div className="side_item-head">
                                    <span className="head-tit">수수료 정보</span>
                                </div>
                                <div className="side_item-body">
                                    <div className="row-item">
                                        <span className="item-tit">플랫폼 수수료</span>
                                        <span className="item-desc">{comma(viewData.totalPlatformCommissionFee || "0")}원</span>
                                    </div>
                                    <div className="row-item">
                                        <span className="item-tit">제휴업체 수수료</span>
                                        <span className="item-desc">{comma(viewData.totalPlatformCommissionShareFee || "0")}원</span>
                                    </div>
                                    <div className="row-item">
                                        <span className="item-tit">수수료 제외 수익</span>
                                        <span className="item-desc">{comma(viewData.totalExceptCommissionFee || "0")}원</span>
                                    </div>
                                    <div className="row-item">
                                        <span className="item-tit">부가세제외</span>
                                        <span className="item-desc">{comma(viewData.totalExceptAddTaxFee || "0")}원</span>
                                    </div>
                                    <div className="row-item">
                                        <span className="item-tit">오더업체 수수료</span>
                                        <span className="item-desc">{comma(viewData.totalOrderCommissionFee || "0")}원</span>
                                    </div>
                                    <div className="row-item">
                                        <span className="item-tit">렌트카 수익</span>
                                        <span className="item-desc">{comma(viewData.totalObtainEarningFee || "0")}원</span>
                                    </div>
                                    <div className="row-item">
                                        <span className="item-tit">총 청구요금</span>
                                        <span className="item-desc">{comma(viewData.totalChargeFee || "0")}원</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="popup-bottom">
                    <button className="btn btn-secondary" onClick={handleAosCharge}>
                        AOS 청구 신청
                    </button>
                    <button className="btn btn-primary" onClick={handleFaxSend}>
                        팩스 전송
                    </button>
                    <button className="btn btn-third" onClick={handleFaxFileCreate}>
                        팩스파일 생성
                    </button>
                    <button className="btn btn-third" onClick={handleFaxFileView}>
                        팩스파일 보기
                    </button>
                    <button className="btn btn-outline" onClick={handleChargeCalculate}>
                        청구 재계산
                    </button>
                    <button className="btn btn-outline" onClick={handleCommission}>
                        수수료 재정산
                    </button>
                    <button className="btn btn-outline" onClick={handleContractDetail}>
                        계약서 상세
                    </button>
                </div>
            </div>
        </>,
        document.body
    );
};
